import middleware from "../../middleware";
import WeaCollet from "../wea-collect";
class WeaCustom extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { children, uuid } = this.props;
    if (children && uuid === "0bd92b22-90f1-4d42-91a4-695adf976bc9") {
      return <div>{children}</div>;
    } else {
      return <div />;
    }
  }
}

const Com = middleware(WeaCustom, "WeaCustom");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-custom/index.js